import http from "./utils";
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
import { overviewOriginType } from '@/pages/opinion/types/performance';
const CancelToken = axios.CancelToken;

export const getGameStoreStatsInfo: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/store/stats`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getGameStoreTimelineInfo: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/store/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const setGameStoreUserCountries: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/set_user_countries`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getGameStoreUserCountries: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/get_user_countries`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getStoreSteamAnalysis: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/overview/steam_analysis`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getGameStoreRelativeDetails: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  return http({
    url: `${prefix}/game/relative_detail
`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};
